import {
    collection,
    getDoc,
    doc,
    getDocs,
    Firestore,
    DocumentData,
    query,
    where,
    limit,
    updateDoc,
    arrayUnion,
    QuerySnapshot,
    arrayRemove,
    Timestamp,
} from "firebase/firestore";
import {
    ProductModel,
    ShoppingCartModel,
    ShoppingCartProduct,
    ShoppingCartProductModel,
} from "./firestoreData.ts";
import { UserModel } from "./firebaseUser.ts";

if(ProductModel){
}

export default class FirestoreHandler {
    // @ts-ignore
    private _firebaseUser: string;
    private _db: Firestore;

    constructor(db: Firestore, firebaseUser: string) {
        this._firebaseUser = firebaseUser;
        this._db = db;
    }

    async GetProductListFromShoppingCartByProject(
        projectId: string
    ): Promise<ShoppingCartModel[] | null> {
        try {
            const q = query(
                collection(this._db, "ShoppingCart"),
                where("project", "==", projectId)
            );
            const querySnapshot = await getDocs(q);
            const documents = new Array<ShoppingCartModel>();
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                documents.push(
                    new ShoppingCartModel({
                        initiator: data.initiator,
                        products: data.products,
                        project: projectId,
                    })
                ); // Push the document data to the array
            });


            // Check for empty array before using
            return documents;
        } catch (error) {
            console.error("Error getting documents:", error);
            return null;
        }
    }


    async GetProductListFromShoppingCartByWorkerInProject(
        id: string,
        projectId: string
    ): Promise<ShoppingCartModel | null> {
        try {
            const q = query(
                collection(this._db, "ShoppingCart"),
                where('project', '==', projectId),
                where('initiatior', '==', id),
                limit(1)
            );
            const querySnapshot: QuerySnapshot<DocumentData> = await getDocs(q);
            if (querySnapshot.empty) {
                console.log("No shopping cart found for this user and project.");
                return null;
            }

            const initiator = await this.GetInitiatorNameById(id);

            if (!initiator) {
                console.log("No initiator found for this shopping cart.");
                return null;
            }


            const shoppingCartObj = new ShoppingCartModel({
                initiator: initiator,
                products: querySnapshot.docs[0].data().products,
                project: projectId,
            });

            return shoppingCartObj;
        } catch (error) {
            console.error("Error fetching shopping cart:", error);
            return null;
        }
    }

    async GetUserInformation(id: string): Promise<UserModel | null> {
        try {
            const docRef = doc(this._db, "user", id);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                return new UserModel({
                    firstname: docSnap.data().firstName,
                    lastname: docSnap.data().lastName,
                    position: docSnap.data().position,
                    project: docSnap.data().project
                });
            } else {
                console.log("No such document!"); // Optional: Log that the document doesn't exist
                return null;
            }
        } catch (error) {
            console.error("Error getting document:", error); // Log the error
            return null; // Return null to indicate failure
        }
    }

    // async GetUserProfile(id: string) {}

    // TODO: belong in the Auth handler
    async GetInitiatorNameById(id: string): Promise<string | null> {
        const docRef = doc(this._db, "user", id);

        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            const firstName: string = docSnap.data().firstName;
            const lastName: string = docSnap.data().lastName;
            return firstName + lastName;
        } else {
            // docSnap.data() will be undefined in this case
            return null;
        }
    }

    async CheckUserPositionInProject(id: string) {
        const docRef = doc(this._db, "user", id);

        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            console.log("Document data:", docSnap.data());
            const position: string = docSnap.data().position;
            return position;
        } else {
            // docSnap.data() will be undefined in this case
            return null;
        }
    }

    // Returns document id when successfully adding shoppingcartproduct, else returns null
    async AddShoppingCartProduct(
        data: ShoppingCartProduct,
        initiator: string,
        projectId: string
    ): Promise<string | null> {
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            const userRef = collection(this._db, "ShoppingCart"); // Reference to the document
            const q = query(
                collection(this._db, "ShoppingCart"),
                where("project", "==", projectId),
                where("initiatior", "==", initiator),
                limit(1)
            );
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                console.log("No shopping cart found for this user and project.");
                return null; // Or return a specific error message if you prefer
            } else {
                const docRef = querySnapshot.docs[0].ref; // Access the first document's ref
                await updateDoc(docRef, {
                    products: arrayUnion(data),
                });
                return docRef.id;
            }
        } catch (e) {
            console.error("Error adding document: ", e);
            return null;
        }
    }

    async AddShoppingCart() {}

    async updateProductAmountInProjectShoppingCart(
        documentId: string,
        arrayFieldName: string,
        targetTimestamp: Timestamp,
        updatedProductData: any // Updated data for the product
    ) {
        try {
            const docRef = doc(this._db, "ShoppingCart", documentId); // Replace "yourCollection"
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const data = docSnap.data();
                const products = data[arrayFieldName] as ShoppingCartProductModel[];

                if (products && products.length > 0) {
                    let foundIndex = -1;

                    for (let i = 0; i < products.length; i++) {
                        if (products[i].timestamp.isEqual(targetTimestamp)) {
                            foundIndex = i;
                            break;
                        }
                    }

                    if (foundIndex !== -1) {
                        // Update the product at the found index
                        products[foundIndex] = { ...products[foundIndex], ...updatedProductData};

                        await updateDoc(docRef, {
                            [arrayFieldName]: products,
                        });

                        console.log("Product updated successfully.");
                    } else {
                        console.log("Product with the specified timestamp not found.");
                    }
                } else {
                    console.log("Array is empty or does not exist.");
                }
            } else {
                console.log("Document not found.");
            }
        } catch (error) {
            console.error("Error updating product:", error);
        }
    }


    // the id is for the shopping cart
    async DeleteOneProductFromProjectShoppingCart(id: string, product: ShoppingCartProduct) {
        try {
            const docRef = doc(this._db, "ShoppingCart", id); // Reference to the documen

            await updateDoc(docRef, {
                products: arrayRemove(product),
            });
            return true;
        }
        catch (error) {
            return false;
        }
    }

    async DeleteAllProjectProductInShoppingCart(id: string): Promise<Boolean | null> {
        try {
            const docRef = doc(this._db, "ShoppingCart", id); // Reference to the document
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const data = docSnap.data();
                const existingArray = data.products as any[]; // Type assertion for flexibility

                if (existingArray && existingArray.length > 0) {
                    await updateDoc(docRef, {
                        products: arrayRemove(...existingArray),
                    });
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    }

    async DeleteAProjectProductsInShoppingCart() {}

    async UpdateShoppingCart() {}
}
